import type { TranslationMessages } from '../../types';

export const dashboard: TranslationMessages = {
  title: 'Bảng điều khiển nhân viên',
  welcome: 'Chào mừng đến với bảng điều khiển nhân viên của bạn',
  quick_actions: 'Hành động nhanh',
  today_summary: 'Tóm tắt hôm nay',
  points_earned: 'Điểm kiếm được',
  hours_worked: 'Giờ làm việc',
  tasks_completed: 'Nhiệm vụ đã hoàn thành',
};
